import React from "react";
import "./Button.css";

const CustomButton = ({ label, onClick, className ,isDisabled }) => {
  return (
    <button className={`custom-button ${className}`} onClick={onClick} disabled={isDisabled}>
      {label}
    </button>
  );
};

export default CustomButton;
